import type { FunctionComponent, PropsWithChildren } from 'react';

import { ActiveThreadStoreProvider } from '../ActiveThreadStoreProvider';
import type { CommentsApi } from '../comments-api-context';
import { BoundCommentsScopeProvider } from '../comments-scope-context';
import type { CommentsSubject } from '../subject/comments-subject';
import { CommentsToggleFocusProvider } from './toggle-focus-context';

type BoundCommentsSurfaceProviderProps = PropsWithChildren<{
    readonly api: CommentsApi;
    readonly subject: CommentsSubject;
}>;

export const BoundCommentsSurfaceProvider: FunctionComponent<BoundCommentsSurfaceProviderProps> = ({
    api,
    children,
    subject,
}) => (
    <BoundCommentsScopeProvider api={api} subject={subject}>
        <ActiveThreadStoreProvider>
            <CommentsToggleFocusProvider>{children}</CommentsToggleFocusProvider>
        </ActiveThreadStoreProvider>
    </BoundCommentsScopeProvider>
);
